/** Entry point for sites under the ici.radio-canada.ca domain.
 * Non-exhaustive list of sites / applications :
 * DotCa (root)
 * Télé (/tele)
 * Mordu (/mordu)
 * Ohdio (/ohdio)
 * Radio-Canada International (/rci)
 * */

import "reflect-metadata"; // Must be first for tsyringe to work correctly!
import "../global";
import { DotCaLib } from "../dotCa/DotCaLib";
import { DataSyncLibEventNames } from "../shared/DataSyncLibEventNames";
import { registerDotCaServices } from "../dotCa/ServicesRegistration";
import { container } from "tsyringe";
import { Logger } from "../utils/Logger";
import addBlueConicScript from "../cdp/AddBlueConicScript";
import { DotCaSiteSettings } from "../dotCa/DotCaSiteSettings";

if (typeof window.gtmDataSyncLib === "undefined") {
  const settings = new DotCaSiteSettings();
  registerDotCaServices();
  Logger.LogEnvironmentMode();

  window.gtmDataSyncLib = container.resolve(DotCaLib);
  addBlueConicScript(settings.BlueConicProductionHostName, settings.ProductionHostNames);
  window.dispatchEvent(new Event(DataSyncLibEventNames.LibraryLoaded));
} else {
  Logger.warn("Warning: attempted double load of the library.");
}
